import { FC } from "react";
import PopupModal from "../../../../UI/Popup";

interface ViewDocumentProps {
  type: string;
  showModal: boolean;
  onClickClose: () => void;
  document: string | null;
  documentName: string | null;
}

const ViewDocument: FC<ViewDocumentProps> = ({
  type,
  showModal,
  onClickClose,
  document,
  documentName
}) => {
  const documentUrl = document ?? "";

  const isImage = /\.(jpg|jpeg|png)$/i.test(documentName ?? "");

  const handleClose = () => {
    onClickClose();
  };

  return (
    <PopupModal
      visible={showModal}
      showCloseBtn={true}
      onClickClose={handleClose}
      customWidth={1000}
    >
      <div className="fs-24 fw-400 text-black">Resume</div>
      <div className="popup-resume">
        {isImage ? (
          <img src={documentUrl} alt={type} className="img" />
        ) : (
          <iframe src={documentUrl} title={type} className="iframe" />
        )}
      </div>
    </PopupModal>
  );
};

export default ViewDocument;
